// extracted by mini-css-extract-plugin
export default {"back_btn_container":"backBtn_back_btn_container__LxSc8","back_btn_icon":"backBtn_back_btn_icon__MKod9","back_btn_title":"backBtn_back_btn_title__ScEKw"};